// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + "2f89cdc4cb0db97e5d96a49a59d2d6901633e53623db8d4c276daa31abb43960" + ".js";
};